export const openVacancy = [
    {
      id:1,
      Title: 'DevOps/Data Engineer (AWS)',
      type:["Remote","Full-Time", "On-site", "On-site", "Part-Time", "Intern"]
    },
    {
      id:2,
      Title: 'Risk Strategy Analyst',
      type:["Remote","Full-Time"]
    },
    {
      id:3,
      Title: 'UX/UI Designer',
      type:["Remote","Full-Time"]
    },
    {
      id:4,
      Title: 'Risk Strategy Analyst',
      type:["Remote","Full-Time"]
    },
    {
      id:5,
      Title: 'Risk Strategy Analyst',
      type:["Remote","Full-Time"]
    },
]

export const vacancyDescription = [
  {
    title: "About RegTechFlow",
    content: [
      "Regulatory Technology, or RegTech, is a rapidly evolving sector that leverages technology to simplify and automate regulatory processes. The main goal of RegTech is to help businesses manage their compliance with government regulations more efficiently and cost-effectively. This involves the use of cloud computing, artificial intelligence (AI), machine learning (ML), and blockchain to transform the way businesses handle compliance-related tasks.",

      "In essence, RegTech helps companies stay on the right side of the law by making regulatory compliance less burdensome. It allows businesses to focus on growth rather than becoming entangled in complex regulatory requirements.",
    ],
  },
  {
    title: "About the role",
    content: [
      "One of the biggest advantages of RegTech is how it improves regulatory reporting. Many businesses are required to regularly submit reports to government agencies or industry regulators. These reports often involve collecting and organizing a lot of data, which can take time and effort.",

      "With RegTech, much of this process can be automated. These tools can pull data from various systems, ensure it's correct, and submit the reports on time with minimal human involvement. This not only reduces the workload for compliance teams but also lowers the chances of errors and missed deadlines. For example, financial institutions can use RegTech to detect and report suspicious activities to meet anti-money laundering (AML) requirements quickly and accurately.",
    ],
  },
  {
    title: "Common RegTech tools and capabilitiesKey responsibilities",
    content: [
      "RegTech simplifies compliance with a variety of tools, including:",
    ],
    tools: [
      {
        name: "Automated Monitoring",
        description:
          "Tracks regulatory changes and keeps businesses updated to ensure ongoing compliance.",
      },
      {
        name: "Risk Management Software",
        description: "Uses AI to identify and mitigate compliance risks.",
      },
      {
        name: "KYC Solutions",
        description:
          "Automates customer identity verification and risk assessments, crucial for preventing fraud.",
      },
      {
        name: "Blockchain for Transparency",
        description:
          "Provides secure, tamper-proof records for better trust and auditability.",
      },
      {
        name: "Cloud-Based Platforms",
        description:
          "Centralize compliance activities, making it easier to track and manage processes efficiently.",
      },
    ],
  },
  {
    title: "Requirements",
    requirements: [
      "Experience of working with PHP for more than 4 years;",
      "Hands-on experience with modern PHP frameworks (Laravel, Symfony)",
      "Knowledge of OOP and common design patterns;",
      "Experience with PHPUnit;",
      "Knowledge of relative and non-relative database technologies: MySQL/MongoDB/PostgreSQL;",
      "Knowledge of UNIX-based operating systems ;",
      "Ability to work with Git",
      "Highly responsible person with analytic thinking and a high sense of punctuality;",
    ],
  },
  {
    title: "What we offer",
    tools: [
      {
        name: "Automated Monitoring",
        description:
          "Tracks regulatory changes and keeps businesses updated to ensure ongoing compliance.",
      },
      {
        name: "Risk Management Software",
        description: "Uses AI to identify and mitigate compliance risks.",
      },
      {
        name: "KYC Solutions",
        description:
          "Automates customer identity verification and risk assessments, crucial for preventing fraud.",
      },
      {
        name: "Blockchain for Transparency",
        description:
          "Provides secure, tamper-proof records for better trust and auditability.",
      },
      {
        name: "Cloud-Based Platforms",
        description:
          "Centralize compliance activities, making it easier to track and manage processes efficiently.",
      },
    ],
  },
];
